/**
 * Mask + Scalp BOGO LP — carousel controls
 */
(() => {
  const initCarousel = (root) => {
    const track = root.querySelector('[data-msb-track]');
    const prev = root.querySelector('[data-msb-prev]');
    const next = root.querySelector('[data-msb-next]');

    if (!track || !prev || !next) return;

    const scrollByCard = (direction) => {
      const card = track.querySelector(':scope > *');
      const amount = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => scrollByCard(-1));
    next.addEventListener('click', () => scrollByCard(1));
  };

  const initAll = () => {
    document.querySelectorAll('[data-msb-carousel]').forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
